import { render, staticRenderFns } from "./ChatIndex.vue?vue&type=template&id=98f1097a&scoped=true&"
import script from "./ChatIndex.vue?vue&type=script&lang=js&"
export * from "./ChatIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChatIndex.vue?vue&type=style&index=0&id=98f1097a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f1097a",
  null
  
)

export default component.exports